export const FETCH_EMPLOYEES = {
  START: 'FETCH_EMPLOYEES_START',
  SUCCESS: 'FETCH_EMPLOYEES_SUCCESS',
  ERROR: 'FETCH_EMPLOYEES_ERROR',
};

export const FETCH_CURRENT_EMPLOYEE = {
  START: 'FETCH_CURRENT_EMPLOYEE_START',
  SUCCESS: 'FETCH_CURRENT_EMPLOYEE_SUCCESS',
  ERROR: 'FETCH_CURRENT_EMPLOYEE_ERROR',
};

export const SAVE_EMPLOYEE = {
  START: 'SAVE_EMPLOYEE_START',
  SUCCESS: 'SAVE_EMPLOYEE_SUCCESS',
  ERROR: 'SAVE_EMPLOYEE_ERROR',
};

export const DELETE_EMPLOYEE = {
  START: 'DELETE_EMPLOYEE_START',
  SUCCESS: 'DELETE_EMPLOYEE_SUCCESS',
  ERROR: 'DELETE_EMPLOYEE_ERROR',
};

export const FETCH_USER_GROUPS = {
  START: 'FETCH_USER_GROUPS_START',
  SUCCESS: 'FETCH_USER_GROUPS_SUCCESS',
  ERROR: 'FETCH_USER_GROUPS_ERROR',
};

export const SAVE_USER = {
  START: 'SAVE_USER_START',
  SUCCESS: 'SAVE_USER_SUCCESS',
  ERROR: 'SAVE_USER_ERROR',
};

export const SET_USER_RIGHTS = {
  START: 'SET_USER_RIGHTS_START',
  SUCCESS: 'SET_USER_RIGHTS_SUCCESS',
  ERROR: 'SET_USER_RIGHTS_ERROR',
};
